// extracted by mini-css-extract-plugin
module.exports = {"measurer":"measurer___1kvFt","correctAnswer":"correctAnswer___1A6qy","incorrectAnswer":"incorrectAnswer___24lwQ"};